module.exports = __webpack_public_path__ + "img/Lotus_Learning.9630a510.jpg";